import { ArrowLeft, HeartPulse } from "lucide-react";
import { Link } from "react-router-dom";

const legalLinks = [
  { to: "/terms", en: "Terms of Use", ar: "شروط الاستخدام" },
  { to: "/privacy", en: "Privacy Policy", ar: "سياسة الخصوصية" },
  { to: "/medical-disclaimer", en: "Medical Disclaimer", ar: "إخلاء المسؤولية الطبية" },
];

export function LegalSection({ titleEn, titleAr, children }) {
  const { childrenEn, childrenAr } = children;

  return (
    <section className="bento-card">
      <div className="grid gap-8 md:grid-cols-2">
        <div dir="ltr" className="text-left space-y-3">
          <h2 className="text-xl font-semibold">{titleEn}</h2>
          <div className="space-y-3 text-sm sm:text-base leading-7 text-muted-foreground">
            {childrenEn}
          </div>
        </div>
        <div dir="rtl" className="text-right space-y-3">
          <h2 className="text-xl font-semibold">{titleAr}</h2>
          <div className="space-y-3 text-sm sm:text-base leading-8 text-muted-foreground">
            {childrenAr}
          </div>
        </div>
      </div>
    </section>
  );
}

export function OwnershipNotice() {
  return (
    <LegalSection titleEn="Ownership Notice" titleAr="إشعار الملكية">
      {{
        childrenEn: (
          <p>
            © 2026 Dialysis Diet Pro. Created for Mr. Antoine [Family Name]. All rights
            reserved. This application, its design, content, and source code may not be
            copied, modified, distributed, or used commercially without written permission
            from the owner.
          </p>
        ),
        childrenAr: (
          <p>
            © 2026 Dialysis Diet Pro. تم إنشاؤه للسيد أنطوان [اسم العائلة]. جميع الحقوق
            محفوظة. لا يجوز نسخ هذا التطبيق أو تصميمه أو محتواه أو شفرته المصدرية أو
            تعديلها أو توزيعها أو استخدامها تجاريا من دون إذن خطي من المالك.
          </p>
        ),
      }}
    </LegalSection>
  );
}

export default function LegalDocument({ titleEn, titleAr, descriptionEn, descriptionAr, children }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border bg-card">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8 h-16 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 font-bold text-base sm:text-lg">
            <span className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center text-primary-foreground">
              <HeartPulse className="w-5 h-5" />
            </span>
            <span>Dialysis Diet Pro</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary">
            <ArrowLeft className="w-4 h-4" />
            <span>Home / الرئيسية</span>
          </Link>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8 py-10 md:py-14">
        <div className="max-w-4xl mb-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-3">
            Legal Information / المعلومات القانونية
          </p>
          <div className="grid gap-4 md:grid-cols-2">
            <div dir="ltr" className="text-left">
              <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">{titleEn}</h1>
              <p className="mt-3 text-muted-foreground leading-7">{descriptionEn}</p>
            </div>
            <div dir="rtl" className="text-right">
              <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">{titleAr}</h1>
              <p className="mt-3 text-muted-foreground leading-8">{descriptionAr}</p>
            </div>
          </div>
        </div>

        <nav aria-label="Legal pages" className="flex flex-wrap gap-2 mb-8">
          {legalLinks.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="px-4 py-2 rounded-full border border-border bg-card text-sm hover:border-primary hover:text-primary transition-colors"
            >
              {item.en} / {item.ar}
            </Link>
          ))}
        </nav>

        <div className="space-y-5">{children}</div>
      </main>

      <footer className="border-t border-border py-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between text-sm text-muted-foreground">
          <span>© 2026 Dialysis Diet Pro. All rights reserved.</span>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {legalLinks.map((item) => (
              <Link key={item.to} to={item.to} className="hover:text-primary">
                {item.en} / {item.ar}
              </Link>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}
